import React, { useEffect, useState } from "react";
import MetaData from "./layout/MetaData";
import { useGetProductsQuery } from "../redux/api/productsApi";
import ProductItem from "./product/ProductItem";
import Loader from "./layout/Loader";
import toast from "react-hot-toast";
import CustomPagination from "./layout/CustomPagination";
import { useSearchParams } from "react-router-dom";
import Filters from "./layout/Filters";

const Home = () => {
    let [searchParams] = useSearchParams();
    const page = searchParams.get("page") || 1;
    const keyword = searchParams.get("keyword") || "";
    const min = searchParams.get("price[gte]");
    const max = searchParams.get("price[lte]");
    const category = searchParams.get("category");
    const ratings = searchParams.get("ratings");
    const orderSuccess = searchParams.get("order_success");
    const keepFilters = searchParams.get("filters") === "1";
    const showFilters = keepFilters || Boolean(keyword || min || max || category || ratings);
    const [showFiltersModal, setShowFiltersModal] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkWidth = () => setIsMobile(window.innerWidth <= 820);
        checkWidth();
        window.addEventListener("resize", checkWidth);
        return () => window.removeEventListener("resize", checkWidth);
    }, []);

    // If redirected with ?order_success=true, silently clean the param
    useEffect(() => {
        if (orderSuccess) {
            const url = new URL(window.location.href);
            url.searchParams.delete("order_success");
            window.history.replaceState({}, "", url.toString());
        }
    }, [orderSuccess]);


    const params = { page, keyword };
    if (min) params.min = min;       // gets mapped to price[gte] in api
    if (max) params.max = max;       // gets mapped to price[lte] in api
    if (category) params.category = category;
    if (ratings) params.ratings = ratings;
    // Decide where to fetch products from based on active filters
    params.displayLocation = showFilters ? 'filter' : 'homepage';




    const { data, isLoading, error, isError } = useGetProductsQuery(params);

    useEffect(() => {
        if (isError) {
            toast.error(error?.data?.message);
        }
    }, [isError, error]);

    const columnSize = showFilters ? 4 : 3;

    if (isLoading) return <Loader />;

    return (
        <>
            <MetaData title={keyword ? `Search: ${keyword}` : "Top Products"} />
            <div className="home-page container my-5">
                <div className="row">
                    {/* Filters Sidebar (when any filter is active) */}
                    {showFilters && !isMobile && (
                        <div className="col-12 col-md-3 col-lg-3 mb-4 mb-md-0">
                            <Filters />
                        </div>
                    )}

                    {/* Main Content */}
                    <div className={(showFilters && !isMobile) ? "col-12 col-md-9" : "col-12"}>
                        {/* Heading */}
                        <div className="text-center mb-5 mt-5">
                            <h1 className="heading text-center ">{showFilters ? "Products 🧚🏻‍♀️" : "Top Products 🧚🏻‍♀️"}</h1>
                        </div>
                        {/* Mobile Filters Button - visible ONLY on filters view */}
                        {showFilters && isMobile && (
                            <div className="text-start mb-3 px-3">
                                <button
                                    type="button"
                                    className="btn filter-btn"
                                    onClick={() => setShowFiltersModal(true)}
                                >
                                    Filters
                                </button>
                            </div>
                        )}

                        {showFilters && showFiltersModal && (
                            <div
                                className="filters-modal-overlay d-flex align-items-center justify-content-center"
                                role="dialog"
                                aria-modal="true"
                                onClick={() => setShowFiltersModal(false)}
                            >
                                <div
                                    className="filters-modal-panel bg-white shadow-sm"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <div className="filters-modal-header d-flex align-items-center justify-content-between">
                                        <h3 className="m-0 visually-hidden">Filters</h3>
                                        <button type="button" className="btn fs-3 lh-1" onClick={() => setShowFiltersModal(false)}>
                                            &times;
                                        </button>
                                    </div>
                                    <div className="filters-modal-body">
                                        <Filters forceInline={true} />
                                    </div>
                                </div>
                            </div>
                        )}



                        {/* Products Section */}
                        <section id="products">
                            <div className="row justify-content-center">
                                {data?.products?.length > 0 ? (
                                    data.products.map((product) => (
                                        <ProductItem key={product._id} product={product} columnSize={columnSize} />
                                    ))
                                ) : (
                                    <p className="text-center">No products found.</p>
                                )}
                            </div>
                        </section>

                        {/* Pagination */}
                        <CustomPagination
                            resPerPage={data?.resPerPage}
                            filteredProductsCount={data?.filteredProductsCount}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Home;